// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__UBh8p","col":"Table_col__3RQv4","fulfillmentStatus":"Table_fulfillmentStatus__3ZtpJ","emailCol":"Table_emailCol__1cUb1"};